import { getDocument, getTimeout } from '@/helpers/globals'

export const createScriptTag = (
    document: Document,
    src: string,
    id?: string
): void => {
    const scriptElement = document.createElement('script')
    scriptElement.async = true
    scriptElement.src = src
    scriptElement.setAttribute('data-cfasync', 'false')
    if (id) {
        scriptElement.id = id
    }

    const firstScript = document.getElementsByTagName('script')[0]
    firstScript?.parentNode?.insertBefore(scriptElement, firstScript)
}

export const importDelayedScript = (
    importer: (document: Document) => void,
    delay = 10_000
): void => {
    if (import.meta.env.SSR) {
        return
    }

    const timeout = getTimeout()
    const document = getDocument()

    if (timeout && document) {
        const { setTimeout } = timeout

        setTimeout(() => {
            importer(document)
        }, delay)
    }
}
